<template>
  <div>
    <div class="container">

      <div class="section">
        <div class="box">
          
          <div class="tabs is-centered">
            <ul>
              <li class="is-active">
                <a>All</a>
              </li>
              <li>
                <a>Plugins</a>
              </li>
              <li>
                <a>Models</a>
              </li>
              <li>
                <a>Personal</a>
              </li>
            </ul>
          </div>

          <div class="field has-addons">
            <div class="control is-expanded">
              <input
                class="input has-text-centered"
                type="search"
                placeholder="» » » » » » find me « « « « « «"
              />
            </div>
            <div class="control">
              <a class="button is-info">Search</a>
            </div>
          </div>
        </div>
        
        <!-- Developers -->
        <div class="row columns">
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">Okinami</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Lead Developer</p>
                  </div>
                </div>
                <div class="content">
                  The Beast stumbled in the dark for it could no longer see the path. It started to fracture and weaken, trying to reshape itself into the form of metal. Even the witches would no longer lay eyes upon it, for it had become hideous and twisted.
                  <div class="background-icon">
                    <span class="icon-twitter"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">McSocks</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Developer</p>
                  </div>
                </div>
                <div class="content">
                  The soul of the Beast seemed lost forever. Then, by the full moon's light, a child was born; child with the unbridled soul of the Beast that would make all others pale in comparison.
                  <div class="background-icon">
                    <span class="icon-facebook"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">The Conceptionist</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Developer</p>
                  </div>
                </div>
                <div class="content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!
                  <div class="background-icon">
                    <span class="icon-barcode"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Developers -->

        <!-- Staff -->
        <div class="row columns is-multiline">
          <div class="column is-one-third">
            <div class="card large round">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">Atsui</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">Sphirou Sapphirou</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">PlayTheFallen</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Sometimes I dip my nose into my cereals. I do it coz it's funny.</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">FelixCAT</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">ScoobyDOG</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">Scrappy Doo</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">Prototyp3</p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4 no-padding">Alex Mack</p>
                    <p>
                      <span class="title is-6">
                        <a href="http://twitter.com/#">@twitterid</a>
                      </span>
                    </p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
          <div class="column is-one-third">
            <div class="card large">
              <div class="card-image">
                <figure class="image">
                  <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-left">
                    <figure class="image is-96x96">
                      <img src="https://bulmatemplates.github.io/bulma-templates/images/admin.png" />
                    </figure>
                  </div>
                  <div class="media-content">
                    <p class="title is-4">Alex Mack</p>
                    <p class="subtitle is-6">Moderator</p>
                  </div>
                </div>
                <div
                  class="content"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!</div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Staff -->
      </div>
    </div>

    <footer class="footer">
      <div class="container">
        <div class="content has-text-centered">
          <div class="soc">
            <a href="#">
              <i class="fa fa-github-alt fa-2x" aria-hidden="true"></i>
            </a>
            <a href="#">
              <i class="fa fa-youtube fa-2x" aria-hidden="true"></i>
            </a>
            <a href="#">
              <i class="fa fa-facebook fa-2x" aria-hidden="true"></i>
            </a>
            <a href="#">
              <i class="fa fa-twitter fa-2x" aria-hidden="true"></i>
            </a>
          </div>
          <p>
            <strong>Bulma</strong> by
            <a href="http://jgthms.com">Jeremy Thomas</a>.
            The source code is licensed
            <a
              href="http://opensource.org/licenses/mit-license.php"
            >MIT</a>.
            <br />
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>
